import { guid } from '@/mixins/guid';

export default function countdown() {
  return {
    _id: false,
    type: 'droplet.countdown',
    clock: {
      sets: [
        {
          _id: guid.methods.guid(),
          end: new Date(),
          endDate: {
            date: new Date().toISOString(),
          },
          endTime: {
            hh: '11',
            HH: '11',
            mm: '59',
            A: 'PM',
          },
          bufferTime: 0,
          bufferDur: 'seconds',
          endMessage: 'Countdown Ended!',
          recurring: false,
          baseColor: 'default',
        },
      ],
    },
    setsString: false,
    custom: false,
    mediaQueries: [
      {
        selector: '.drzCountdown-section',
        properties: [
          {
            defaultColor: true,
            property: 'background-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'color',
            desktop: 'rgba(255, 255, 255, 1)',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        global: true,
        selector: '.drzCountdown-clock',
        properties: [
          {
            property: 'float',
            desktop: 'left',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
    ],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/countdown/droplet.schema.js